<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <div v-if="dataPermission && dataPermission.includes('CNPS_CALENDAR_AFS_INSERT')">
        <form @submit.prevent="handleSubmit(submitRequest)">
          <div class="breadcrumb-area pos-relative w-100">
            <h1>{{ dataDetail.calendarId ? 'Sửa' : 'Thêm mới' }} công việc</h1>
            <div style="float: right">
              <button type="button" @click="backToCalendar" class="btn btn-light">Hủy bỏ</button>
              <button class="btn btn-success btn-primary ml-2">
                {{ dataDetail.calendarId ? 'Chỉnh sửa' : 'Thêm mới' }}
              </button>
            </div>
          </div>
          <!-- -------Content-----`- -->
          <div class="card p-10 pt-15 b-t-1-869fb229" style="overflow-x: hidden; overflow-y: auto">
            <div class="card-body px-20 row">
              <form class="col-md-6">
                <ValidationProvider rules="required" vid="type" name="Nhóm công việc">
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label">
                      Nhóm công việc<span style="color: red"> *</span>
                    </label>
                    <div class="col-sm-9">
                      <Select2
                        @change="onChangeType(dataDetail.type)"
                        v-model="dataDetail.type"
                        :options="optionsType"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>

                <!-- <div class="form-group row">
              <label for="" class="col-sm-3 col-form-label">Thời gian dự kiến:</label>
              <div class="col-sm-9">
                <DateRangePicker
                  class="w-100"
                  :ranges="false"
                  v-model="dateRange"
                  :timePicker="true"
                  :locale-data="localeData"
                  :timePicker24Hour="true"
                >
                  <template v-slot:input="picker">
                    <label style="min-width: 13.5em" class="text-left pt-1">
                      {{ picker.startDate | formatDate('HH:mm DD/MM/YYYY')}} -
                      {{ picker.endDate | formatDate('HH:mm DD/MM/YYYY') }}
                    </label>
                  </template>
                </DateRangePicker>
              </div>
          </div> -->

                <div class="form-group row">
                  <label for="" class="col-sm-3 col-form-label">Thời gian dự kiến:</label>
                  <div class="col-sm-9">
                    <InputRange v-model="dateRange"></InputRange>
                  </div>
                </div>

                <ValidationProvider rules="required" vid="purposes" name="Tên công việc">
                  <div class="form-group row" slot-scope="{ errors }">
                    <label for="" class="col-sm-3 col-form-label"
                      >Tên công việc<span style="color: red"> *</span></label
                    >
                    <div class="col-sm-9">
                      <Select2MultipleControl
                        :settings="{ multiple: false }"
                        v-model="dataDetail.purposes"
                        :options="optionsPurpose"
                      >
                      </Select2MultipleControl>
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>

                <ValidationProvider rules="required" vid="Merchant" name="Merchant">
                  <div class="form-group row select-merchant" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label">
                      Chọn MC<span style="color: red"> *</span>
                    </label>
                    <div class="col-sm-9">
                      <input
                        type="hidden"
                        class="form-control text-left"
                        v-model="merchantSelected"
                      />
                      <input
                        type="text"
                        class="form-control text-left"
                        :value="
                          merchantSelected.merchantName ? `${merchantSelected.merchantName}` : ''
                        "
                        readonly
                        placeholder="Chọn merchant"
                        v-b-modal.select-merchant-dialog
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                    <div @click="clearMerchant()" class="clear-merchant">x</div>
                  </div>
                </ValidationProvider>

                <ValidationProvider rules="required" vid="saleId" name="Người xử lý">
                  <div class="form-group row" slot-scope="{ errors }">
                    <label for="" class="col-sm-3 col-form-label"
                      >Người xử lý:<span style="color: red"> *</span></label
                    >
                    <div class="col-sm-9">
                      <Select2 v-model="dataDetail.saleId" :options="optionsStaff"> </Select2>
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider rules="required" vid="informSource" name="Nguồn báo">
                  <div class="form-group row" slot-scope="{ errors }">
                    <label for="" class="col-sm-3 col-form-label"
                      >Nguồn báo:<span style="color: red"> *</span></label
                    >
                    <div class="col-sm-9">
                      <Select2 v-model="dataDetail.informSource" :options="informSources">
                      </Select2>
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider rules="required" vid="informant" name="Người báo">
                  <div class="form-group row" slot-scope="{ errors }">
                    <label for="" class="col-sm-3 col-form-label"
                      >Người báo:<span style="color: red"> *</span></label
                    >
                    <div class="col-sm-9">
                      <input type="text" class="form-control" v-model="dataDetail.informant" />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider rules="required" vid="inform" name="Hình thức báo">
                  <div class="form-group row" slot-scope="{ errors }">
                    <label for="" class="col-sm-3 col-form-label"
                      >Hình thức báo:<span style="color: red"> *</span></label
                    >
                    <div class="col-sm-9">
                      <Select2 v-model="dataDetail.inform" :options="informs"> </Select2>
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider rules="required" vid="note" name="Lý do">
                  <div class="form-group row" slot-scope="{ errors }">
                    <label for="" class="col-sm-3 col-form-label"
                      >Lý do:<span style="color: red"> *</span></label
                    >
                    <div class="col-sm-9">
                      <Select2MultipleControl
                        v-if="['MC_INACTIVE', 'MC_DECREASE_TPV'].includes(dataDetail.type)"
                        :settings="{ closeOnSelect: false }"
                        v-model="dataDetail.noteArr"
                        :options="resonArr"
                      >
                      </Select2MultipleControl>
                      <input
                        v-else
                        type="text"
                        class="form-control datetimes"
                        v-model="dataDetail.note"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>

                <div class="form-group row">
                  <label for="" class="col-sm-3 col-form-label">Mô tả:</label>
                  <div class="col-sm-9">
                    <input
                      type="text"
                      class="form-control datetimes"
                      id=""
                      v-model="dataDetail.description"
                    />
                  </div>
                </div>
              </form>
              <form class="col-md-6">
                <UploadMultiple
                  @syncFile="syncFile"
                  :lsData="fileUploads"
                  maxFil="100"
                  uniqueKey="images"
                  title="Ảnh giải trình"
                  titleTag="h1"
                  titleClass="form-inner-heading"
                />
              </form>
            </div>
          </div>
        </form>
      </div>
    </ValidationObserver>
    <SelectMerchant @selectMerchant="onSelectMerchant" />
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { CalendarAfsService } from '@/services/calendar-afs.service'
  import Config from '../../../thirdParty/config'
  import { StaffService } from '@/services/staff.service'
  import UploadMultiple from '@/components/UploadMultiple.vue'
  import { v4 as uuidv4 } from 'uuid'
  import cloneDeep from 'lodash/cloneDeep'
  import { CommonService } from '@/services/common.service'
  import { MerchantService } from '@/services/merchant.service'
  import SelectMerchant from '@/components/SelectMerchant.vue'
  import mxItemAction from './mx-item-action.js'
  import InputRange from '@/components/InputRange.vue'

  export default {
    mixins: [mxItemAction],
    components: { UploadMultiple, SelectMerchant, InputRange },
    data() {
      return {
        dataDetail: {
          images: [],
          noteArr: [],
        },
        optionsType: Config.jobTypes,
        localeData: Config.localeData,
        dateRange: {
          startDate: null,
          endDate: null,
        },
        optionsPurpose: Config.jobPurposes,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        optionsStaff: [],
        informSources: Config.informSources,
        informs: Config.informs,
        fileUploads: [],
        showLoading: false,
        merchantSelected: {},
        resonArr: [],
      }
    },
    methods: {
      async fetchData() {
        try {
          const id = this.$route.params.id
          this.showLoading = true
          const data = await CalendarAfsService.getTaskAFSDetailById({ id })
          if (data.success) {
            this.merchantSelected = data.data
            this.merchantSelected.merchantName = data.data.customerInfoRes.merchantName
            this.onSelectMerchant(data.data)
            this.onChangeType(data.data.type)
            this.dataDetail = {
              calendarId: id,
              customerId: data.data.customerInfoRes.customerId,
              customerName: data.data.customerInfoRes.merchantName,
              endIntend: data.data.endIntend,
              id: data.data.id,
              images: data.data.images ? data.data.images : [],
              inform: data.data.inform,
              informSource: data.data.informSource,
              informant: data.data.informant,
              name: data.data.name,
              note: data.data.note,
              description: data.data.description,
              noteArr: data.data.note?.split(', '),
              purposes: data.data.purposes,
              result: data.data.result,
              saleId: data.data.handlerRes.id,
              startIntend: data.data.startIntend,
              type: data.data.type,
              saleOfflineSignedImage: data.data.saleOfflineSignedImage,
            }
            const mappingData = (arr, type) =>
              arr.forEach(url => {
                const ar = { name: url, url, type, id: uuidv4() }
                this.fileUploads.push(ar)
              })
            mappingData(data.data.images, 'images')
            this.dateRange = {
              startDate: data.data.startIntend,
              endDate: data.data.endIntend,
            }
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      onSelectMerchant(mc) {
        this.merchantSelected = mc
        this.dataDetail.customerId = mc.customerId
        this.dataDetail.customerName = mc.customerName
      },

      backToCalendar() {
        this.$router.push({ path: '/calendar-afs' })
      },
      async onChangeType(data) {
        const res = mxItemAction.onChangeType(data)
        res.then(result => {
          this.resonArr = result
        })
      },
      async submitRequest() {
        try {
          this.showLoading = true
          const files = await Promise.all(this.fileUploads.map(s => this.sendFile(s)))
          this.dataDetail.images = files.map(s => s.urlFile)
          const startTime = new Date(this.dateRange.startDate)
          const endTime = new Date(this.dateRange.endDate)
          this.dataDetail.startIntend = startTime.getTime()
          this.dataDetail.endIntend = endTime.getTime()
          if (!this.dataDetail.startIntend) delete this.dataDetail.startIntend
          if (!this.dataDetail.endIntend) delete this.dataDetail.endIntend
          const params = cloneDeep(this.dataDetail)
          if (['MC_INACTIVE', 'MC_DECREASE_TPV'].includes(params.type)) {
            params.note = params.noteArr.join(', ')
          }
          params.purposes = Array.isArray(params.purposes) ? params.purposes : [params.purposes]
          if (params.note) {
            if (this.dataDetail.calendarId) {
              const response = await CalendarAfsService.EditCalendarAFS(params)
              if (response.code === 1000) {
                this.showSuccessMx('Chỉnh sửa thành công').then(() =>
                  this.$router.push('/calendar-afs')
                )
              } else {
                this.showFailMx(response.message)
              }
            } else {
              const response = await CalendarAfsService.addCalendarAFS(params)
              if (response.code === 1000) {
                this.showSuccessMx('Thêm mới thành công').then(() =>
                  this.$router.push('/calendar-afs')
                )
              } else {
                this.showFailMx(response.message)
              }
            }
          } else this.showFailMx('Lý do k được để trống')
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async getStaff() {
        try {
          const response = await StaffService.getStaffByIdSuperior({ userId: this.dataUser.userId })
          this.optionsStaff = response.data.map(item => {
            return {
              id: item.userId,
              text: item.name,
            }
          })
        } catch (error) {
          console.log(error)
        }
      },
      syncFile(files) {
        this.fileUploads = files
      },
      async sendFile(item) {
        if (item.file && item.status !== 'uploaded') {
          const formData = new FormData()
          formData.append('files', item.file)
          formData.append('folderName', 'NextCrm')
          const data = await CommonService.uploadImg(formData)
          const urlFile = data.data[0]
          item.url = urlFile
          item.status = 'uploaded'
          return { urlFile, type: item.type }
        } else return { urlFile: item.url, type: item.type }
      },
      async getMerchant() {
        try {
          const response = await MerchantService.merchantDetail({
            customerId: this.$route.query.customerId,
          })
          return response.data
        } catch (error) {}
      },
      clearMerchant() {
        this.merchantSelected = {}
        delete this.dataDetail.customerId
      },
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    async created() {
      this.getStaff()
      if (this.$route.params.id) this.fetchData()
      if (this.$route.query.purpose) {
        this.dataDetail.purposes = this.$route.query.purpose
      }
      if (this.$route.query.customerId) {
        const mc = await this.getMerchant()
        this.onSelectMerchant(mc)
      }
    },
  }
</script>
<style scoped>
  .select-merchant {
    position: relative;
  }
  .clear-merchant {
    position: absolute;
    right: 22px;
    top: 10px;
    font-size: 14px;
    cursor: pointer;
  }
</style>
